'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = batchedAdd;
function batchedAdd(singleFn, batchedFn) {
    var queue = [];
    var numInLastSec = 0;
    var isLooping = false;
    var loopInterval = 1000;

    function queueLoop() {
        numInLastSec = 0;
        if (queue.length) {
            var q = queue;
            queue = [];
            batchedFn(q);
            numInLastSec = 0;
            setTimeout(queueLoop, loopInterval);
        } else {
            isLooping = false;
        }
    }

    function maybeStartLoop() {
        if (isLooping) {
            return;
        }

        isLooping = true;
        setTimeout(queueLoop, loopInterval);
    }

    function resetAddCounter(doResetNum) {
        if (doResetNum) {
            numInLastSec = 0;
        }
        if (!isLooping) {
            setTimeout(resetAddCounter, 1000, true);
        }
    }

    function batchFn(item) {
        numInLastSec++;

        if (queue.length || numInLastSec > 3) {
            queue.push(item);
            maybeStartLoop();
        } else {
            singleFn(item);
            resetAddCounter();
        }
    }
    batchFn.queue = function getQueue() {
        return queue;
    };

    return batchFn;
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["batchedAdd"]
window._kiwi_exports.libs.batchedAdd = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/batchedAdd.js
// module id = Tddf
// module chunks = 1